
import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

import { useTutorKanbanStore } from './store'

interface TutorKanbanPolicyReturn {
  setEdit: () => void
}

export const useTutorKanbanPolicy = (): TutorKanbanPolicyReturn => {
  const tutorKanbanStore = useTutorKanbanStore()

  const setEdit = (): void => {
    const url = resolveUrl(AppRoute.TutorsPaymentPolicy, { id: tutorKanbanStore.getTutor?.id })

    void navigateTo(url)
  }

  return {
    setEdit,
  }
}
